import React from 'react';
import classes from "./style.module.scss"
import useStyles from 'isomorphic-style-loader/useStyles'
import MeChildHeader from '../../../../components/me-child-header';
import RightToLeft from '../../../../../../components/transitions/right-to-left';
import { useIntl } from 'react-intl';

const List = props => {
    const {toChangeLanguage, languageLocale, onClose, languages} = props
    const Intl = useIntl()

    return (
        <div className={classes.ListBox}>
            <MeChildHeader name={Intl.formatMessage({id: 'language'})} onBack={() => onClose()}/>
            <div className={classes.List}>
                <ul>
                    {
                        languages?.map((item, index) => (
                            <li className={classes.Item} key={item?.value+index} onClick={() => toChangeLanguage(item?.value)}>
                                <span className={`${languageLocale === item.value ? classes.active: ''}`}>{item?.label}</span>
                            </li>
                        ))
                    }
                </ul>
            </div>
        </div>
    )
}

const LanguageList = props => {
    useStyles(classes)
    const { show } = props || {}

    return (
            <RightToLeft in={show} className={classes.LanguageListPage}>
                <div>
                    <List {...props} />
                </div>
            </RightToLeft>
    )
}

export default LanguageList